import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-margin ml-2 mb-1" }
const _hoisted_2 = { class: "text-raleway-13 uppercase" }
const _hoisted_3 = { class: "d-flex pointer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("input", {
  value: "percent",
  type: "radio",
  id: "percent",
  class: "pointer display-none",
  name: "margin"
}, null, -1)
const _hoisted_5 = { class: "d-flex pointer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  value: "absolute",
  type: "radio",
  id: "absolute",
  class: "pointer display-none",
  name: "margin"
}, null, -1)

import { IStore } from "../../../../chat_brave_developers_front/src/redux/type";
import { ref, computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'marginTypeComponents',
  setup(__props) {

const store = useStore<IStore>();
const marginType = ref(computed<string>(() => store.getters.getMargin));
const setMarginType = (type: string) => store.commit("setMargin", type);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("Margin")), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("label", {
        for: "percent",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setMarginType('percent'))),
        class: "text-motserrat-13-light pointer text-nowrap d-flex"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["margin-circle", { select: marginType.value === 'percent' }])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.$tc("Calculation in %")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("label", {
        for: "absolute",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setMarginType('absolute'))),
        class: "text-motserrat-13-light pointer text-nowrap d-flex"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["margin-circle", { select: marginType.value === 'absolute' }])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.$tc("Calculation in absolute units")), 1)
      ])
    ])
  ]))
}
}

})